import {StateId} from '@wallaby-ui/core';
import {createSelector} from 'reselect';

import {getGridStateId as getGridStateIdHelper} from './grid_helpers';
import {GridParams, PerformedAction} from './grid_slice';
import {TableConfigRaw} from 'src/js/model/table_config';
import {RootState} from 'src/js/store';

interface SelectorProps {
  gridStateId?: string;
  gridId: string;
}

const STATIC_EMPTY_ARRAY = [];

export const getGridStateId = (
  state: RootState,
  props: Pick<SelectorProps, 'gridStateId' | 'gridId'>
): StateId => props.gridStateId ?? getGridStateIdHelper(props.gridId);

export const getGridParams = (
  state: RootState,
  props: Pick<SelectorProps, 'gridStateId' | 'gridId'>
): GridParams => state[getGridStateId(state, props)]?.gridParams;

const getPerformedActions = (
  state: RootState,
  props: Pick<SelectorProps, 'gridStateId' | 'gridId'>
): PerformedAction[] =>
  state[getGridStateId(state, props)].performedActions ?? STATIC_EMPTY_ARRAY;

export const getGridConfig = (
  state: RootState,
  props: Pick<SelectorProps, 'gridStateId' | 'gridId'>
): TableConfigRaw | undefined => state[getGridStateId(state, props)].gridConfig;

export const getGridSort = createSelector([getGridParams], (gridParams) =>
  gridParams ? gridParams.sort : undefined
);

export const getGridPagination = createSelector([getGridParams], (gridParams) =>
  gridParams ? gridParams.pagination : undefined
);

export const getGridFilters = createSelector([getGridParams], (gridParams) =>
  gridParams ? gridParams.filters : undefined
);

export const getCurrentFilterButton = createSelector(
  [getGridParams],
  (gridParams) => (gridParams ? gridParams.filterButtonId : undefined)
);

export const getGridScroll = createSelector([getGridParams], (gridParams) =>
  gridParams ? gridParams.scroll : undefined
);

export const getIsPerformingAction = createSelector(
  [getPerformedActions],
  (performedActions) => performedActions.length > 0
);
